// extracted by mini-css-extract-plugin
export default {"container":"AuthLoader_container__rYiFX","logoContainer":"AuthLoader_logoContainer__Vroo2","spin":"AuthLoader_spin__XXE7+","loading_span":"AuthLoader_loading_span__4LYj2"};